var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRhombus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "#F66524",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07102 4.53537L4.80322 0.267578L0.53543 4.53537L4.80322 8.80316L9.07102 4.53537Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRhombus);
export default __webpack_public_path__ + "static/media/IconRhombus.cfd0ac0242c89e490390aabb8e594857.svg";
export { ForwardRef as ReactComponent };